import axios from "axios";
// initial state
const state = {
  amount:localStorage.getItem('amount') || null
};

// getters
const getters = {};

// actions
const actions = {
  AddPaypalPayment({ commit }, list) {
    return new Promise(resolve => {
      axios({
        url: "/payments/create",
        data: list,
        method: "POST"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },

/*  PaymentStripe({commit}, list){
    state.amount=list.amount
    localStorage.setItem("amount", list.amount);
    // commit('setAmount',{ amount })
     return new Promise((resolve, reject) => {
      axios({
        url: '/payments/stripe/checkout',
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
        },
        data :{
          "amount":list.amount
        }
      }).then(res => {
        resolve(res)
      })
        .catch(err => {
          reject(err);
        });
    })
  },*/

  GetPaymentList({ commit }, list) {
    return new Promise(resolve => {
      axios({
        url: "/payment/list?order_by=paid_on&order_dir=desc",
        params: {
          page: list.page,
          search: list.search ? list.search : '',
          company_name: list.company_name ? `${list.company_name}*` : '',
          per_page: list.per_page ? list.per_page : '',
          company_uuid: list.company_uuid,
          order_by: list.order_by || null,
          order_dir: list.order_dir || null
        },
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  AddPayment({ commit }, payment) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/payment',
        method: "POST",
        data: {
          method: 'manual',
          amount: payment.amount,
          reseller_uuid: payment.reseller_uuid || null,
          company_uuid: payment.company_uuid || null
        },
      }).then(res => {
        resolve(res)
      })
        .catch(err => {
          reject(err);
        });
    })
  },
  GetBalance({ commit }, company_uuid) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/company/list?' + company_uuid,
        method: "GET",
      }).then(res => {
        resolve(res)
      })
        .catch(err => {
          reject(err);
        });
    })
  },
  PaymentStripe({ commit }, list){
    state.amount=list.amount
    localStorage.setItem("amount", list.amount);
    // commit('setAmount',{ amount })
     return new Promise((resolve, reject) => {
      axios({
        url: '/payments/stripe/checkout',
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
        },
        data :{
          "amount":list.amount
        }
      }).then(res => {
        resolve(res)
      })
        .catch(err => {
          reject(err);
        });
    })
  },
  
};

// mutations
const mutations = {
  setUser: (state, user) => {
    state.user = user;
  },
  setAmount: (state,amount) => {
    state.amount = amount;
    console.log(state)
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
